import React from 'react'
import moment from 'moment'
import EdicionBuques from '../containers/EdicionBuques'
import DeleteBodegaBuque from '../components/DeleteBodegaBuque'
import OperacionesDetalleCarga from '../components/anunciobuques/OperacionesDetalleCarga'
import ToneladasACargar from '../components/anunciobuques/ToneladasACargar'

export const EMPLY_BUQUE = {
  nombre: '',
  nombreCorto: '',
  imo: '',
  pais: ''
}

export const COLUMNS_BODEGAS_BUQUE = [
  {
    name: 'nombre',
    label: 'Bodega',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'detalle',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (detalle) => {
        return <DeleteBodegaBuque buque={detalle.buque} bodega={detalle.nombre} />
      }
    }
  }
]

export const COLUMNS_LISTADO_BUQUES = [
  {
    name: 'nombreCorto',
    label: 'Nombre Corto',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'nombre',
    label: 'Nombre',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'bandera',
    label: 'Bandera',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'eslora',
    label: 'Eslora',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'manga',
    label: 'Manga',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'imo',
    label: '# IMO',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'nombreCorto',
    label: ' ',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: value => {
        return <EdicionBuques nombre={value} />
      }
    }
  }
]

export const COLUMNS_LISTADO_BUQUES_TO_PRINT = [
  {
    name: 'nombre',
    label: 'Nombre',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'nombreCorto',
    label: 'Nombre Corto',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'bandera',
    label: 'Bandera',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'eslora',
    label: 'Eslora',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'manga',
    label: 'Manga',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoBruto',
    label: 'Peso Bruto',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoDeDesplazamiento',
    label: 'Peso Desplazamiento',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'mmsi',
    label: '# MMSI',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'imo',
    label: '# IMO',
    width: 50,
    mantenerCase: true
  }
]

export const COLUMNS_CARGA_BUQUES = [
  {
    name: 'fechaDeCarga',
    label: 'Fecha de carga',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (f) => {
        return moment(f).format('DD/MM/YYYY')
      }
    }
  },
  {
    name: 'buque',
    label: 'Buque',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'nombreExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'entry',
    label: 'Toneladas',
    options: {
      filter: false,
      sort: true,
      total: true,
      totalFloat: 'center',
      customBodyRender: (entry) => {
        const value = entry['toneladas']
        return <ToneladasACargar value={value} entry={entry} />
      }
    }
  },
  {
    name: 'entry',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      displayCOlumn: false,
      customBodyRender: (entry) => {
        return (<OperacionesDetalleCarga data={entry} />)
      }
    }
  }

]
